import { type FocusEvent } from 'react';
import { Controller, type Control } from 'react-hook-form';

import { useTranslate, type CardOptionType } from 'hooks';
import type { PaymentType } from 'types';
import { Input } from 'views/components/fonbet/ui';

import { type CardFieldsType } from './type';

type Props = {
  control: Control<CardFieldsType, any>;
  selectedCard: CardOptionType;
  paymentData: PaymentType;
  amount: string;
  onHandleFocus: (e: FocusEvent<HTMLInputElement>) => void;
};

const CvvInput = ({ control, selectedCard, paymentData, amount, onHandleFocus }: Props) => {
  const { t } = useTranslate();

  return (
    <Controller
      name="cvv"
      control={control}
      rules={
        selectedCard.newCard
          ? {
              required: true,
              pattern: {
                value: /^\d{3,4}$/,
                message: t('wrong_cvv'),
              },
            }
          : undefined
      }
      render={({ field: { value, onChange, ref }, fieldState: { error } }) => (
        <Input
          name="cvv"
          mask=""
          placeholder="CVC"
          format={selectedCard.newCard ? '###' : '***'}
          inputClassName="w-20 md:w-[90px]"
          value={value}
          onChange={onChange}
          onFocus={onHandleFocus}
          ref={ref}
          info={selectedCard.newCard ? t('1xbet.form-bank-card.input.cvv.tooltip') : undefined}
          showPass
          allowEmptyFormatting={!selectedCard.newCard}
          type={selectedCard.newCard ? 'password' : 'tel'}
          error={error?.message}
          disabled={paymentData.commission > amount || !selectedCard.newCard}
        />
      )}
    />
  );
};

export default CvvInput;
